export const AGENT_MODEL_VALUES = [
  'gpt-5',
  'gpt-5-mini',
  'gpt-5-nano',
  'gpt-4.1',
  'gpt-4.1-mini',
  'gpt-4.1-nano',
  'o3',
  'o3-mini',
  'gpt-4o',
  'gpt-4o-mini',
] as const;

export type AgentModel = (typeof AGENT_MODEL_VALUES)[number];

export const AGENT_PROVIDER_VALUES = ['openai', 'anthropic'] as const;

export type AgentProvider = (typeof AGENT_PROVIDER_VALUES)[number];

export const AGENT_MODEL_LABELS: Record<AgentModel, string> = {
  'gpt-5': 'GPT-5',
  'gpt-5-mini': 'GPT-5 Mini',
  'gpt-5-nano': 'GPT-5 Nano',
  'gpt-4.1': 'GPT-4.1',
  'gpt-4.1-mini': 'GPT-4.1 Mini',
  'gpt-4.1-nano': 'GPT-4.1 Nano',
  o3: 'O3',
  'o3-mini': 'O3 Mini',
  'gpt-4o': 'GPT-4o',
  'gpt-4o-mini': 'GPT-4o Mini',
};

export const AGENT_PROVIDER_LABELS: Record<AgentProvider, string> = {
  openai: 'OpenAI',
  anthropic: 'Anthropic',
};
